module.exports = __webpack_public_path__ + "img/nseguidores.f6f58903.svg";